import {
  type BillingState,
  type DeliveryNoteAdminLineItemEnhanced,
} from '../types';

/**
 * Calculates the billing state of a delivery note based on the line items.
 * The billing state in the delivery note is unreliable as it only differentiates between 'no invoices received' and 'invoices received'.
 * @param lineItems - The line items of the delivery note.
 * @returns The billing state of the delivery note.
 */
export const getCalculatedBillingState = (
  lineItems: DeliveryNoteAdminLineItemEnhanced[],
): BillingState => {
  if (!lineItems?.length) {
    return 'unbilled';
  }

  const isFullyBilled = lineItems?.every(
    (lineItem) =>
      Boolean(lineItem?.billingState?.totalBilledQuotient) &&
      lineItem?.billingState?.totalBilledQuotient === 1,
  );

  if (isFullyBilled) {
    return 'fullyBilled';
  }

  const isPartiallyBilled = lineItems?.some((lineItem) =>
    Boolean(lineItem?.billingState?.totalBilledQuotient),
  );

  if (isPartiallyBilled) {
    return 'partiallyBilled';
  }

  return 'unbilled';
};
